import { showNotification } from '../../../helper/showNotification';
import ButtonCopyGameLink from './ButtonCopyGameLink';
import ButtonShareGameLink from './ButtonShareGameLink';
import QrCode from './QrCode';
import Modal, { type ModalProps } from '../../../components/Modal';

type Props = ModalProps & {
  gameId: string | undefined;
};

function SharingModal({ close, gameId, show }: Props) {
  if (!gameId) {
    showNotification('GameId not available', 'warn');
    return <></>;
  }

  return (
    <Modal show={show} close={close}>
      <>
        <div className="mb-4">
          <h4>Spiel ID:</h4>
          <h2>{gameId}</h2>
        </div>

        <QrCode gameId={gameId} />
        <div className="mt-6 flex flex-col items-center space-y-4">
          <ButtonCopyGameLink gameId={gameId} />
          <ButtonShareGameLink gameId={gameId} />
        </div>
      </>
    </Modal>
  );
}

export default SharingModal;
